import styled from "styled-components";
// eslint-disable-next-line import/no-extraneous-dependencies
import { Button } from "manifest-components/src/Button";
import { fetchUserAttributes, signOut } from "aws-amplify/auth";
import { useEffect, useState } from "react";
import Authentication from "../../../utils/authentication";
import { RoutePaths, useTypedNavigate } from "../../../routes/RoutePaths";

const StyledPage = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const NewHomePage = () => {
  console.log("new home page");
  const navigate = useTypedNavigate();
  const [user, setUser] = useState<{ name: string }>({ name: "" });
  // STEP ONE: get token & User details
  useEffect(() => {
    const init = async () => {
      const userRes = await fetchUserAttributes();
      setUser({ name: userRes.given_name || "" });
    };
    init();
  }, []);

  const signOutHandler = () => {
    signOut();
    Authentication.clear();
    return navigate(RoutePaths.index);
  };

  // TODO: others

  return (
    <StyledPage>
      {user.name && (
        <>
          Hi {user.name}
          <Button onClick={signOutHandler} text="Sign out" name="signOut" />
        </>
      )}
    </StyledPage>
  );
};

export default NewHomePage;
